var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGauge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.085,
    height: 70.084,
    viewBox: "0 0 70.085 70.084",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1786",
    "data-name": "Group 1786",
    transform: "translate(-74 -277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_45",
    "data-name": "Subtraction 45",
    d: "M35.042,70.084A35.051,35.051,0,0,1,21.4,2.754,35.051,35.051,0,0,1,48.682,67.33,34.823,34.823,0,0,1,35.042,70.084Zm0-61.554A26.512,26.512,0,1,0,61.555,35.042,26.542,26.542,0,0,0,35.042,8.53Z",
    transform: "translate(74 277)",
    fill: "#c2c4c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_48",
    "data-name": "Subtraction 48",
    d: "M35.042,70.084a35.3,35.3,0,0,1-7.062-.712A34.85,34.85,0,0,1,15.45,64.1a35.15,35.15,0,0,1-12.7-15.418A34.87,34.87,0,0,1,.712,42.1a35.377,35.377,0,0,1,0-14.124,34.815,34.815,0,0,1,4.381-11.14l6.922,5.029A26.524,26.524,0,1,0,35.042,8.53V0A35.3,35.3,0,0,1,42.1.712a34.833,34.833,0,0,1,12.53,5.273A35.153,35.153,0,0,1,67.331,21.4a34.854,34.854,0,0,1,2.041,6.578,35.377,35.377,0,0,1,0,14.124A34.835,34.835,0,0,1,64.1,54.634a35.142,35.142,0,0,1-15.417,12.7A34.874,34.874,0,0,1,42.1,69.372,35.289,35.289,0,0,1,35.042,70.084Z",
    transform: "translate(74 277)",
    fill: "#575757"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGauge);
export default __webpack_public_path__ + "static/media/gauge.0839ca6bd936d7127b484d3d8faf97f8.svg";
export { ForwardRef as ReactComponent };